import * as React from 'react';

var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgBasics = function SvgBasics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5ZM40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M19 9c4.344-.065 8.699 2.934 11.378 5.876l.002.003a2.412 2.412 0 0 1 0 3.23l-.002.002c-.345.38-.718.76-1.113 1.134a.75.75 0 1 1-1.03-1.09c.368-.348.713-.7 1.032-1.05a.912.912 0 0 0 0-1.22c-2.565-2.817-6.541-5.446-10.255-5.384h-.024c-3.713-.062-7.69 2.567-10.253 5.387a.913.913 0 0 0 .001 1.221l.002.002a18.098 18.098 0 0 0 6.8 4.758.75.75 0 1 1-.555 1.394 19.599 19.599 0 0 1-7.362-5.151 2.413 2.413 0 0 1 0-3.229l.003-.002C10.3 11.934 14.656 8.935 19 9Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M20.2 13.753a2.999 2.999 0 0 0-2.4 5.497.75.75 0 0 1-.6 1.374 4.499 4.499 0 1 1 5.925-2.324.75.75 0 0 1-1.375-.6 2.999 2.999 0 0 0-1.55-3.947Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M17.5 26.25a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0ZM24.25 21a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M27.374 23.905a.75.75 0 0 1 .15 1.05l-2.905 3.874a1.503 1.503 0 0 1-2.261.16l-1.5-1.5a.75.75 0 1 1 1.06-1.06l1.5 1.5h.002l2.904-3.874a.75.75 0 0 1 1.05-.15Z",
    clipRule: "evenodd"
  })));
};

export { SvgBasics as default };
//# sourceMappingURL=basics.svg.js.map
